import './styles/graphic.scss';
import json from './data/data.json';

const params = new URLSearchParams(location.search);
const area = params.get('area');

// Filter out released alive and released dead
const data = json.filter(person => person.grouping !== 'released-alive' && person.grouping !== 'released-dead');

export default function (props, container) {
  const hostageCountElement = document.querySelector('#hostage-count');
  if (hostageCountElement) {
    hostageCountElement.textContent = data.length;
  }

  // Create popup modal box for each persons bio
  const modal = container.append('div')
    .attr('class', 'modal')
    .style('display', 'none');

  const modalContent = modal.append('div')
    .attr('class', 'modal-content');

  const closeBtn = modalContent.append('span')
    .attr('class', 'modal-close')
    .html('&times;')
    .on('click', () => {
      modal.style('display', 'none');
    });

  const modalHeader = modalContent.append('div')
    .attr('class', 'modal-header');

  const modalImage = modalHeader.append('img')
    .attr('class', 'modal-image');

  const modalInfo = modalHeader.append('div')
    .attr('class', 'modal-info');

  const modalName = modalInfo.append('h3')
    .attr('class', 'modal-name');

  const modalAge = modalInfo.append('p')
    .attr('class', 'modal-age');

  const modalStatus = modalInfo.append('p')
    .attr('class', 'modal-status');

  const modalNote = modalContent.append('div')
    .attr('class', 'modal-bio-container');

  const modalNav = modalContent.append('div')
    .attr('class', 'modal-nav');

  // Create next/previous button
  const prevBtn = modalNav.append('button')
    .attr('class', 'modal-nav-btn modal-nav-btn-prev')
    .html('<svg class="arrow-left" width="20" height="18" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" fill="currentColor" viewBox="0 0 20 18"><path d="M19.7967 9.06344L11.9428 16.9388C11.6717 17.2105 11.2324 17.2105 10.961 16.9388C10.69 16.667 10.69 16.2263 10.961 15.9545L17.5835 9.25701H0.68964C0.161428 9.25701 0 8.91844 0 8.60202C0 8.24595 0.283927 7.88559 0.68964 7.88559H17.5863L10.961 1.18812C10.69 0.916335 10.69 0.475623 10.961 0.203838C11.2324 -0.0679461 11.6717 -0.0679461 11.9428 0.203838L19.7967 8.07916C20.0678 8.35095 20.0678 8.79166 19.7967 9.06344Z"></path></svg>');

  const navCounter = modalNav.append('span')
    .attr('class', 'modal-nav-counter')
    .style('color', '#666')
    .style('font-size', '14px');

  const nextBtn = modalNav.append('button')
    .attr('class', 'modal-nav-btn modal-nav-btn-next')
    .html('<svg class="arrow-right" width="20" height="18" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" fill="currentColor" viewBox="0 0 20 18"><path d="M19.7967 9.06344L11.9428 16.9388C11.6717 17.2105 11.2324 17.2105 10.961 16.9388C10.69 16.667 10.69 16.2263 10.961 15.9545L17.5835 9.25701H0.68964C0.161428 9.25701 0 8.91844 0 8.60202C0 8.24595 0.283927 7.88559 0.68964 7.88559H17.5863L10.961 1.18812C10.69 0.916335 10.69 0.475623 10.961 0.203838C11.2324 -0.0679461 11.6717 -0.0679461 11.9428 0.203838L19.7967 8.07916C20.0678 8.35095 20.0678 8.79166 19.7967 9.06344Z"></path></svg>');

  let currentPersonIndex = 0;
  let allPeople = [];


  function updateModalContent(person, index) {
    currentPersonIndex = index;

    modalImage.attr('src', person.image).attr('alt', person.name).attr('class', `modal-image ${person.grouping}`);
    modalName.text(person.name).attr('class', `modal-name ${person.grouping}`);

    const ageDisplay = person.age === 'Age unknown' ? person.age : `Age ${person.age}`;
    modalAge.html(ageDisplay);
    modalStatus.text(`${groupTitles[person.grouping]}`);

    modalNote.html('');
    const bioLines = person.bio ? person.bio.split('\n').filter(line => line.trim()) : [];
    bioLines.forEach((line) => {
      modalNote.append('p')
        .attr('class', 'modal-bio')
        .text(line);
    });

    navCounter.text(`${index + 1} of ${allPeople.length}`);

    prevBtn.attr('disabled', index === 0 ? true : null);
    nextBtn.attr('disabled', index === allPeople.length - 1 ? true : null);
  }

  prevBtn.node().addEventListener('click', (e) => {
    e.stopPropagation();
    if (currentPersonIndex > 0) {
      updateModalContent(allPeople[currentPersonIndex - 1], currentPersonIndex - 1);
    }
  });

  nextBtn.node().addEventListener('click', (e) => {
    e.stopPropagation();
    if (currentPersonIndex < allPeople.length - 1) {
      updateModalContent(allPeople[currentPersonIndex + 1], currentPersonIndex + 1);
    }
  });

  modalContent.node().addEventListener('click', (e) => {
    e.stopPropagation();
  });

  modal.node().addEventListener('click', () => {
    modal.style('display', 'none');
  });

  const groupedData = data.reduce((acc, item) => {
    const group = item.grouping;
    if (!acc[group]) {
      acc[group] = [];
    }
    acc[group].push(item);
    return acc;
  }, {});

  // Define group order and display names
  // Can add/remove groups here and set what title will appear above their group
  const groupOrder = ['presumed-dead', 'status-unknown'];
  const groupTitles = {
    'presumed-dead': 'Deceased',
    'status-unknown': 'Status unknown',
  };

  groupOrder.forEach((groupKey) => {
    if (groupedData[groupKey]) {
      allPeople = allPeople.concat(groupedData[groupKey]);
    }
  });

  groupOrder.forEach((groupKey) => {
    if (groupedData[groupKey]) {
      const groupSection = container.append('div')
        .attr('class', `group-section ${groupKey}`);

      const groupTitleElement = groupSection.append('h2')
        .attr('class', 'group-title');

      groupTitleElement.append('span')
        .text(groupTitles[groupKey]);

      const profilesContainer = groupSection.append('div')
        .attr('class', 'profiles-container');

      groupedData[groupKey].forEach((person) => {
        const prof = profilesContainer.append('div')
          .attr('class', 'profile')
          .style('cursor', 'pointer')
          .on('click', () => {
            const personIndex = allPeople.findIndex(p => p === person);
            updateModalContent(person, personIndex);

            const groupRect = groupSection.node().getBoundingClientRect();
            const modalContentNode = modalContent.node();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            modalContentNode.style.position = 'absolute';
            modalContentNode.style.top = `${groupRect.top + scrollTop + groupRect.height / 2}px`;
            modalContentNode.style.left = `${groupRect.left + groupRect.width / 2}px`;
            // modalContentNode.style.transform = 'translate(-50%, -60%)';

            modal.style('display', 'block');
          });

        const image = prof.append('div')
          .attr('class', 'image-container')
          .attr('id', person.name.replace(/\s+/g, '-').toLowerCase());

        image.append('img')
          .attr('src', `${person.image}`)
          .attr('alt', person.name);

        const labels = prof.append('div')
          .attr('class', 'titles');

        labels.append('span')
          .attr('class', 'name')
          .text(`${person.name}`);

        labels.append('span')
          .attr('class', 'age')
          .html(person.age);
      });
    }
  });
}
